module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_3016.2662e8ea.png";